/* Smart Home PRO — klijentski filteri po karakteristikama.
   Čita data-f-* atribute sa kartica proizvoda (generiše ih
   snippets/sh-filter-attrs.liquid) i gradi panel sa checkbox
   filterima. Radi bez ijedne aplikacije — sve je u kodu teme. */
(function () {
  'use strict';

  var state = {}; // key -> {} mapa izabranih vrednosti
  var suppress = 0; // ignoriši mutacije koje sami izazovemo

  function panelEl() { return document.getElementById('ShFilters'); }
  function gridEl() { return document.getElementById('product-grid'); }

  function items() {
    var g = gridEl();
    return g ? Array.prototype.slice.call(g.querySelectorAll(':scope > .grid__item')) : [];
  }

  function valsOf(li, key) {
    var a = li.getAttribute('data-f-' + key);
    return a ? a.split('|').filter(Boolean) : [];
  }

  function selected(key) {
    return state[key] ? Object.keys(state[key]) : [];
  }

  function matches(li, groups, skipKey) {
    for (var i = 0; i < groups.length; i++) {
      var k = groups[i].k;
      if (k === skipKey) continue;
      var sel = selected(k);
      if (!sel.length) continue;
      var vals = valsOf(li, k);
      var hit = false;
      for (var j = 0; j < sel.length; j++) {
        if (vals.indexOf(sel[j]) > -1) { hit = true; break; }
      }
      if (!hit) return false;
    }
    return true;
  }

  function anyActive(groups) {
    return groups.some(function (g) { return selected(g.k).length > 0; });
  }

  function apply(groups) {
    var panel = panelEl();
    var list = items();
    var shown = 0;
    list.forEach(function (li) {
      var ok = matches(li, groups, null);
      li.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });

    // grupisan prikaz: sakrij prazne grupe i ažuriraj brojeve u naslovima i pilulama
    var g0 = gridEl();
    if (g0) {
      var activeF = anyActive(groups);
      Array.prototype.slice.call(g0.querySelectorAll(':scope > li.sh-group-row')).forEach(function (row) {
        var el = row.nextElementSibling;
        var vis = 0;
        while (el && !el.classList.contains('sh-group-row')) {
          if (el.classList.contains('grid__item') && el.style.display !== 'none') vis++;
          el = el.nextElementSibling;
        }
        row.style.display = vis ? '' : 'none';
        var cnt = row.querySelector('.sh-group-count');
        if (cnt) {
          if (!cnt.getAttribute('data-sh-orig')) cnt.setAttribute('data-sh-orig', cnt.textContent);
          cnt.textContent = activeF ? '(' + vis + ')' : cnt.getAttribute('data-sh-orig');
        }
        if (row.id) {
          var pill = document.querySelector('.sh-group-nav a[href="#' + row.id + '"]');
          if (pill) {
            pill.style.display = vis ? '' : 'none';
            var ps = pill.querySelector('span');
            if (ps) {
              if (!ps.getAttribute('data-sh-orig')) ps.setAttribute('data-sh-orig', ps.textContent);
              ps.textContent = activeF ? '(' + vis + ')' : ps.getAttribute('data-sh-orig');
            }
          }
        }
      });
    }

    // ažuriraj brojeve pored opcija
    panel.querySelectorAll('input[data-key]').forEach(function (inp) {
      var k = inp.getAttribute('data-key');
      var v = inp.value;
      var c = 0;
      list.forEach(function (li) {
        if (matches(li, groups, k) && valsOf(li, k).indexOf(v) > -1) c++;
      });
      var lab = inp.closest('label');
      var span = lab.querySelector('.sh-count');
      if (span) span.textContent = '(' + c + ')';
      lab.classList.toggle('sh-zero', c === 0 && !inp.checked);
    });

    // poruka kada nema rezultata
    var grid = gridEl();
    var empty = document.getElementById('ShFiltersEmpty');
    if (shown === 0 && list.length) {
      if (!empty) {
        suppress = Date.now() + 400;
        empty = document.createElement('div');
        empty.id = 'ShFiltersEmpty';
        empty.className = 'sh-empty';
        empty.innerHTML = 'Nijedan proizvod ne odgovara izabranim filterima.<br><button type="button" class="sh-reset-link">Poništi filtere</button>';
        grid.parentNode.insertBefore(empty, grid);
        empty.querySelector('.sh-reset-link').addEventListener('click', function () { resetAll(groups); });
      }
      empty.style.display = '';
    } else if (empty) {
      empty.style.display = 'none';
    }

    // dugme za poništavanje
    var rb = panel.querySelector('.sh-reset');
    if (rb) rb.style.display = anyActive(groups) ? '' : 'none';

    // broj proizvoda
    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var pc = document.getElementById(id);
      if (!pc) return;
      var orig = pc.getAttribute('data-sh-orig') || pc.textContent.trim();
      pc.textContent = anyActive(groups)
        ? 'Prikazano: ' + shown + ' od ' + list.length
        : orig;
    });
  }

  function resetAll(groups) {
    state = {};
    var panel = panelEl();
    panel.querySelectorAll('input[data-key]').forEach(function (i) { i.checked = false; });
    apply(groups);
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function build() {
    var panel = panelEl();
    var grid = gridEl();
    if (!panel || !grid) return;
    var groups;
    try { groups = JSON.parse(panel.getAttribute('data-groups') || '[]'); } catch (e) { return; }
    var list = items();

    // zapamti "originalni" broj proizvoda dok je tekst ažuran
    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var pc = document.getElementById(id);
      if (pc) {
        var t = pc.textContent.trim();
        if (t.indexOf('Prikazano') !== 0) pc.setAttribute('data-sh-orig', t);
      }
    });

    // 1) izračunaj dostupne vrednosti po grupi
    var unions = {};
    groups.forEach(function (g) {
      var union = [];
      list.forEach(function (li) {
        valsOf(li, g.k).forEach(function (v) {
          if (union.indexOf(v) === -1) union.push(v);
        });
      });
      union.sort(function (a, b) { return a.localeCompare(b, 'sr', { numeric: true }); });
      unions[g.k] = union;
    });

    // 2) očisti izbore koji više ne postoje na ovoj strani
    //    (da ne ostane "nevidljiv" aktivan filter posle Dawn AJAX izmene)
    Object.keys(state).forEach(function (k) {
      var u = unions[k] || [];
      Object.keys(state[k]).forEach(function (v) {
        if (u.indexOf(v) === -1) delete state[k][v];
      });
      if (!Object.keys(state[k]).length) delete state[k];
    });

    // 3) zapamti koje su grupe otvorene pre ponovnog renderovanja
    var openKeys = {};
    var hadGroups = false;
    panel.querySelectorAll('details.sh-group').forEach(function (d) {
      hadGroups = true;
      if (d.open) openKeys[d.getAttribute('data-key')] = true;
    });

    var html = '';
    groups.forEach(function (g) {
      var union = unions[g.k];
      if (!union.length) return;
      var isOpen = hadGroups ? !!openKeys[g.k] : window.innerWidth >= 990;
      html += '<details class="sh-group" data-key="' + esc(g.k) + '"' + (isOpen ? ' open' : '') + '><summary><span>' + esc(g.l) + '</span></summary><div class="sh-options">';
      union.forEach(function (v) {
        var checked = state[g.k] && state[g.k][v] ? ' checked' : '';
        html += '<label class="sh-opt"><input type="checkbox" data-key="' + esc(g.k) + '" value="' + esc(v) + '"' + checked + '><span class="sh-box"></span><span class="sh-val">' + esc(v) + '</span><span class="sh-count"></span></label>';
      });
      html += '</div></details>';
    });

    if (!html) {
      panel.style.display = 'none';
      panel.innerHTML = '';
      return;
    }
    panel.style.display = '';
    var note = document.querySelector('.pagination')
      ? '<p class="sh-note">Filteri se primenjuju na proizvode prikazane na ovoj strani.</p>'
      : '';
    panel.innerHTML =
      '<div class="sh-head"><h2 class="sh-title">Karakteristike</h2>' +
      '<button type="button" class="sh-reset" style="display:none">Poništi ✕</button></div>' + html + note;

    panel.querySelector('.sh-reset').addEventListener('click', function () { resetAll(groups); });
    panel.onchange = function (e) {
      var t = e.target;
      if (!t || !t.hasAttribute('data-key')) return;
      var k = t.getAttribute('data-key');
      state[k] = state[k] || {};
      if (t.checked) state[k][t.value] = 1;
      else delete state[k][t.value];
      apply(groups);
    };
    apply(groups);
  }

  function init() {
    build();
    // Dawn facets (cena/dostupnost/sortiranje) AJAX-om menjaju grid — ponovo izgradi panel
    var container = document.getElementById('ProductGridContainer');
    if (container && !container.__shObserved) {
      container.__shObserved = true;
      var t;
      new MutationObserver(function () {
        if (Date.now() < suppress) return;
        clearTimeout(t);
        t = setTimeout(build, 120);
      }).observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
